export default function truncate_chars(
  str: string | undefined,
  n: number = 30,
  terminator: string = "…"
): string {
  if (str && str.length > n) {
    return str.substring(0, n) + terminator
  }
  return str || ""
}
